import React, { memo } from 'react';
import { CloudSync, PencilSquare, Users } from '@sharefiledev/icons';
import { Tooltip } from 'antd';
import { ComponentTypes, Field, IRecipient } from '../../../common/componentUtils';
import { Role, Variable } from '../../../data/interfaces/DocumentTemplate';
import { SchemaProperty } from '../../../data/interfaces/SchemaResponse';
import { t } from '../../../utils';
import { Annotations } from './Annotations';
import { StyledLeftPanel, StyledTabs } from './LeftPanel.styled';
// import { SenderFields } from './SenderFields';
import { SignerFields } from './SignerFields';
import { SystemFields } from './SystemFields';

interface Props {
	roles: IRecipient[] | undefined;
	fields: Field[] | undefined;
	selectedRole: IRecipient | null;
	selectedField: ComponentTypes | null;
	onSelectRole: (value: string) => void;
	onSelectField: (type: ComponentTypes | null) => void;
	onSaveRole: (role: Role) => void;
	variables: Variable[] | undefined;
	onSaveVariables: () => void;
	onSelectVariable: (value: Variable) => void;
	selectedVariable: Variable | null;
	selectedProperty: SchemaProperty;
	setSelectedProperty: (property: SchemaProperty) => void;
}

export const LeftPanel = memo(
	({
		roles,
		fields,
		selectedRole,
		selectedField,
		onSelectRole,
		onSelectField,
		onSaveRole,
		variables,
		onSaveVariables,
		onSelectVariable,
		selectedVariable,
		selectedProperty,
		setSelectedProperty,
	}: Props) => {
		const items = [
			{
				icon: Users,
				toolTip: t('leftNav.signerFields'),
				key: 'signer-fields',
				content: (
					<SignerFields
						roles={roles}
						fields={fields}
						selectedRole={selectedRole}
						selectedField={selectedField}
						onSelectRole={onSelectRole}
						onSelectField={onSelectField}
						onSaveRole={onSaveRole}
					/>
				),
			},
			{
				icon: CloudSync,
				toolTip: t('leftNav.systemFilled.toolTip'),
				key: 'system-fields',
				content: (
					<SystemFields
						variables={variables}
						onSelectVariable={onSelectVariable}
						selectedVariable={selectedVariable}
						onSelectField={onSelectField}
						selectedProperty={selectedProperty}
						setSelectedProperty={setSelectedProperty}
						onSaveVariables={onSaveVariables}
					/>
				),
			},
			// {
			// 	icon: UserSettings,
			// 	toolTip: t('leftNav.senderFields'),
			// 	key: 'sender-fields',
			// 	content: <SenderFields />,
			// },
			{
				icon: PencilSquare,
				toolTip: t('leftNav.annotateDocument'),
				key: 'annotations',
				content: (
					<Annotations
						selectedField={selectedField}
						onSelectField={onSelectField}
						onSelectTab={onSelectRole}
					/>
				),
			},
		];
		const ontabChange = (key: string) => {
			if (key === 'annotations') {
				onSelectRole(null);
				onSelectVariable(null);
			} else if (key === 'signer-fields') {
				onSelectRole(roles[0]?.id);
				onSelectVariable(null);
			} else if (key === 'system-fields') {
				onSelectRole(null);
				onSelectVariable(variables?.[0]);
			}
			setSelectedProperty(null);
		};

		return (
			<StyledLeftPanel id="tabs-container" style={{ position: 'relative' }}>
				<StyledTabs
					tabPosition="left"
					onTabClick={ontabChange}
					items={items.map(({ icon: Icon, toolTip, ...item }) => {
						return {
							label: '',
							key: item.key,
							icon: (
								<Tooltip placement="right" title={toolTip}>
									<Icon size={16} aria-label={toolTip} />
								</Tooltip>
							),
							children: <div style={{ padding: '16px 8px' }}>{item.content}</div>,
						};
					})}
				/>
			</StyledLeftPanel>
		);
	}
);
